import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import UAParser from 'ua-parser-js';

import './style.scss';

import DocumentIcon from './icons/document.inline.svg';
import LinkIcon from './icons/link.inline.svg';
import PlusIcon from './icons/plus.inline.svg';
import CrossIcon from './icons/cross.inline.svg';
import ReplayIcon from './icons/replay.inline.svg';

function checkUA(ua) {
  let parser = new UAParser();
  let result = parser.getResult();

  if (result.os.name === ua) {
    return '';
  } else {
    return '=';
  }
}

const Button = props => {
  const renderIcon = () => {
    switch (props.icon) {
      case 'document':
        return <DocumentIcon />;
      case 'link':
        return <LinkIcon />;
      case 'plus':
        return <PlusIcon />;
      case 'cross':
        return <CrossIcon />;
      case 'replay':
        return <ReplayIcon />;
      default:
        return null;
    }
  };

  if (props.openInNewTab || props.annualReportPage || props.download) {
    return (
      <a
        href={
          props.annualReportPage
            ? `/annual-report-2020-2021/pdfs/Professional_Standards_Councils_Annual_Report_2020-21.pdf#page${checkUA('iOS')}${props.annualReportPage}`
            : props.to
        }
        className={`button is-${props.color}`}
        target="_blank"
        rel="noopener noreferrer"
        // download={props.download}
        disabled={props.disabled}
      >
        {renderIcon()}
        {props.label}
        {/* {checkUALabel('Android') ? 'Download' : props.label} */}
        <span className="sr-only">&nbsp;{props.srLabelContinuation}</span>
      </a>
    );
  }

  if (props.to) {
    return (
      <Link to={props.to} className={`button is-${props.color}`} disabled={props.disabled}>
        {renderIcon()}
        {props.label}
        <span className="sr-only">&nbsp;{props.srLabelContinuation}</span>
      </Link>
    );
  }

  return (
    <button className={`button is-${props.color}`} disabled={props.disabled} onClick={props.onClick}>
      {renderIcon()}
      {props.label}
      <span className="sr-only">&nbsp;{props.srLabelContinuation}</span>
    </button>
  );
};

Button.propTypes = {
  to: PropTypes.string,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  srLabelContinuation: PropTypes.string,
  icon: PropTypes.oneOf(['document', 'link', 'plus', 'cross', 'replay']),
  openInNewTab: PropTypes.bool,
  download: PropTypes.bool,
  disabled: PropTypes.bool,
  annualReportPage: PropTypes.number,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  to: '',
  icon: null,
  onClick: () => {},
};

export default Button;
